module.exports = __webpack_public_path__ + "img/pdf_logo.6e23e336.png";